import { FormControlLabel, Switch, Typography } from '@mui/material'
import { useCredentialTypeContext } from './CredentialTypeProvider'

type Props = {
  onChange: (checked: boolean) => void
  checked?: boolean
  disabled?: boolean
  forCredential?: boolean
}

export default function VendorRollUpLineItemsSwitch({
  onChange,
  checked,
  disabled,
  forCredential,
}: Props) {
  const credentialType = useCredentialTypeContext()
  return (
    <FormControlLabel
      control={
        <Switch checked={!!checked} sx={{ mx: 1 }} disabled={disabled} />
      }
      label={
        <>
          <Typography>Roll Up Line Items</Typography>
          <Typography variant="caption" color="text.secondary">
            {forCredential
              ? 'Determines the default behavior for rolling up line items when exporting an invoice or receipt for any vendor using this credential. Individual vendors can override this default in their own settings.'
              : `When exporting an invoice or receipt for this vendor to 
            ${credentialType.name}, roll all line items up into a single line
            item.`}
          </Typography>
        </>
      }
      onChange={(_e, checked) => {
        onChange(checked)
      }}
    />
  )
}
